export const VALUE_DELIMITER = '" or "'

/**
 * private_security's own asset-type list excludes the two flows that already
 * fix their type — a fund files under "private fund" and a piece under "fine
 * art and collectables" no matter what the user types, so offering either
 * here would create a second, indistinguishable route to the same wizard
 * those two already own. Mirrors the legacy wizard's own `ASSET_TYPE_EXCLUDES`.
 * Shared between the wizard's own select (`Wizards/utils/options.ts`) and the
 * same list quoted to the model (`store/ai/assetWizard/index.ts`), so the two
 * cannot drift apart.
 */
export const PRIVATE_SECURITY_TYPE_EXCLUDES = ['private fund', 'fine art and collectables']
